import { createSelector } from '@reduxjs/toolkit';
import { DirectSalesLine, DirectSalesLineObjective } from 'components/common/types/DirectSalesCampaign.types';
import { POI } from 'components/common/types/Planner.types';
import { Store } from 'components/common/types/Store.types';

const hasPoi = (poi?: POI[]): boolean => !!poi?.length;

const hasObjectivePoi = (objectives?: DirectSalesLineObjective[]): boolean =>
  (objectives ?? []).some((objective) => hasPoi(objective.poi));

export const getDirectSalesPoiPoints = createSelector(
  (state: Store) => state.dealManagement.directSales.poiPoints,
  (points) => points ?? [],
);

export const getIsAnyDirectSalesLineHasPoi = createSelector(
  [
    (state: Store) => state.dealManagement.backupFormData.lines,
    (state: Store) => state.dealManagement.commonDeal.currentLine.lineId,
    (state: Store) => state.dealManagement.directSales.poi,
    (state: Store) => state.dealManagement.directSales.objectives,
  ],
  (lines, currentLineId, currentLinePoi, currentLineObjectives = []) => {
    if (!lines.length) {
      return hasPoi(currentLinePoi) || hasObjectivePoi(currentLineObjectives);
    }

    return lines.some((line) => {
      const directSalesLine = line as DirectSalesLine;
      const isCurrentLine = line.lineId === currentLineId;
      const poi = isCurrentLine ? currentLinePoi : directSalesLine.poi;
      const objectives = isCurrentLine ? currentLineObjectives : directSalesLine.objectives;

      return hasPoi(poi) || hasObjectivePoi(objectives);
    });
  },
);
